<template>
  <div :class="classes">
    <input
      :id="id"
      :type="type"
      :placeholder="placeholder"
      :value="modelValue"
      :class="[
        {
          'has-error': hasError,
          'input-with-icon': icon,
          'read-only-no-styling': !readonlyHasStyling
        },
        'form-control w-full',
        'form-control-' + size,
        'text-' + size,
        classes
      ]"
      :iconPosition="iconPosition"
      :readonly="readonly"
      :pattern="pattern"
      :min="min"
      :max="max"
      :aria-label="alt"
      @input="updateValue"
      @focus="inputFocus"
      @blur="inputBlur"
    />
    <Icon
      v-if="icon"
      class="input-icon"
      :class="['input-icon-' + iconPosition + '-' + size]"
      :type="icon"
    />
  </div>
</template>

<script setup>
// TODO: Rename this component to InputText
import Icon from '@/components/icon/Icon.vue'
defineProps({
  placeholder: {
    type: String,
    default: null
  },
  id: {
    type: String,
    default: null
  },
  modelValue: {
    type: String,
    default: null
  },
  type: {
    type: String,
    default: 'text'
  },
  min: {
    type: Number,
    default: null
  },
  max: {
    type: Number,
    default: null
  },
  pattern: {
    type: String,
    default: null
  },
  hasError: {
    type: Boolean,
    default: false
  },
  icon: {
    type: String,
    default: null
  },
  iconPosition: {
    type: String,
    default: 'left'
  },
  readonly: {
    type: Boolean,
    default: false
  },
  readonlyHasStyling: {
    type: Boolean,
    default: true
  },
  classes: {
    type: String,
    default: ''
  },
  size: {
    type: String,
    default: 'md'
  },
  alt: {
    type: String,
    default: null
  }
})
const emit = defineEmits(['update:modelValue', 'focus', 'blur'])
const updateValue = event => {
  emit('update:modelValue', event.target.value)
}

const inputFocus = event => {
  emit('focus', event.target.value)
}
const inputBlur = event => {
  emit('blur', event.target.value)
}
</script>

<style>
.input-with-icon {
  position: relative;
}

.input-icon {
  color: var(--text-tertiary);
  position: relative;
  z-index: 2;
}

.input-icon-left-md {
  float: left;
  margin-left: 11px;
  margin-top: -28px;
  margin-right: 8px;
}
.input-icon-right-md {
  float: right;
  margin-right: 11px;
  margin-top: -28px;
}
.input-icon-left-sm {
  float: left;
  font-size: var(--text-sm);
  margin-left: 10px;
  margin-top: -22px;
}
.input-icon-right-sm {
  float: right;
  font-size: var(--text-sm);
  margin-top: -22px;
}

.input-with-icon[iconPosition='left'].form-control-sm {
  padding-left: 30px !important;
}

.input-with-icon[iconPosition='right'].form-control-sm {
  padding-right: 30px !important;
}

.input-with-icon[iconPosition='left'].form-control-md {
  padding-left: 35px !important;
}

.input-with-icon[iconPosition='right'].form-control-md {
  padding-right: 35px !important;
}
</style>
